import { instance as axios } from '../untils/http'
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { errorHandler } from '../untils/errorHandler';
import { ErrorInformation } from 'src/models/errorInformation';
import { ExcerciseOptionView , AddCartView , PostAddCart
, PaymentmodeDetail } from 'src/models/rptExcerciseOption';

//================|| OPTION PERSONAL LEDGER SLICE ||=================//
type ExcerciseOptionState = {
    loading: boolean;
    error: ErrorInformation;
    excerciseOptionView: ExcerciseOptionView;
    addCartView: AddCartView;
    postAddCart: PostAddCart;
    paymentmodeDetail: PaymentmodeDetail[];
    NewUserResponseMessage: string;
}

const initialState: ExcerciseOptionState = {
    loading: true,
    error: null,
    excerciseOptionView: {
        options: [],
        userName: '',
        userNric: '',
        exerciseCart: 0,
        isBlackoutPeriod: false,
        blackoutPeriodFrom: '',
        blackoutPeriodTo: '',
    },
    addCartView: {
        addEditOptions: [],
        grantNo: '',
        numberOfOptionInCart: 0,
    },
    postAddCart: {
        exerciseCartoptions: [],
        isCDPCompleted: false,
        isCPFCompleted: false,
        result: 0
    },
    paymentmodeDetail: [],
    NewUserResponseMessage: '',
};

type grantNoAndValue = {
    grantNo: string,
    optionExercised: number,
}
type excercise = {
    exerciseID: number
}
type confirmvalues = {
    paymentTypeID: string,
    bankName: string,
    chequeNo: string,
}

export const getExcerciseOptionView = createAsyncThunk<ExcerciseOptionView, {}, { rejectValue: ErrorInformation }>(
    "excerciseOption/getExcerciseOptionView",
    async ({ }, { rejectWithValue }) => {
        try {
            const excerciseOptionViewResponse = await axios.get<ExcerciseOptionView>('MyOption/GetExerciseOptionView');
            return excerciseOptionViewResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getAddEditOption = createAsyncThunk(
    "excerciseOption/getAddEditOption",
    async (grantID: number, { rejectWithValue }) => {
        try {
            const rptPerformancePersonalLedgerViewResponse = await axios.get<AddCartView>(`MyOption/GetAddEditOption?GrantNo=${grantID}`)
            return rptPerformancePersonalLedgerViewResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const postAddEditOption = createAsyncThunk(
    "excerciseOption/postAddEditOption",
    async (grantNoAndValue: grantNoAndValue, { rejectWithValue }) => {
        try {
            const optionpostAddEditOption = await axios.post<PostAddCart>('MyOption/PostAddEditOption',{
                grantNo: grantNoAndValue.grantNo.toString(),
                optionExercised: grantNoAndValue.optionExercised
            });
            console.log(optionpostAddEditOption.data);
            return optionpostAddEditOption.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const postExercisedOptionForCancel = createAsyncThunk(
    "excerciseOption/postExercisedOptionForCancel",
    async (excercise: excercise, { rejectWithValue }) => {
        try {
            const optionpostExercisedOptionForCancel = await axios.post<PostAddCart>('MyOption/PostExercisedOptionForCancel',{
                exerciseID: excercise.exerciseID
            });
            return optionpostExercisedOptionForCancel.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getExerciseCart = createAsyncThunk<PostAddCart, {}, { rejectValue: ErrorInformation }>(
    "excerciseOption/getExerciseCart",
    async ({ }, { rejectWithValue }) => {
        try {
            const getExerciseCartResponse = await axios.get<PostAddCart>('MyOption/GetExerciseCart');
            return getExerciseCartResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getPaymentType = createAsyncThunk<PaymentmodeDetail, {}, { rejectValue: ErrorInformation }>(
    "excerciseOption/getPaymentType",
    async ({ }, { rejectWithValue }) => {
        try {
            const getPaymentTypeResponse = await axios.get<PaymentmodeDetail>('Misc/GetPaymentType');
            console.log(getPaymentTypeResponse.data);
            return getPaymentTypeResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const postConfirmExercise = createAsyncThunk(
    "excerciseOption/postConfirmExercise",
    async (confirmvalues: confirmvalues, { rejectWithValue }) => {
        try {
            const optionpostConfirmExercise = await axios.post('MyOption/PostConfirmExercise',{
                paymentTypeID: confirmvalues.paymentTypeID.toString(),
                bankName: confirmvalues.bankName.toString(),
                chequeNo: confirmvalues.chequeNo.toString(),
            });
            return optionpostConfirmExercise.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

const ExcerciseoptionSlice = createSlice({
    name: 'excerciseOption',
    initialState,
    reducers: {},
    extraReducers: {
        //get Excercise Option View
        [getExcerciseOptionView.pending.type]: (state) => {
            state.loading = true;
        },
        [getExcerciseOptionView.fulfilled.type]: (state, action) => {
            state.excerciseOptionView = action.payload;
            state.loading = false;
        },
        [getExcerciseOptionView.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Add Cart Excercise Option View
        [getAddEditOption.pending.type]: (state) => {
            state.loading = true;
        },
        [getAddEditOption.fulfilled.type]: (state, action) => {
            state.addCartView = action.payload;
            state.loading = false;
        },
        [getAddEditOption.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //post Add Cart Excercise Option View
        [postAddEditOption.pending.type]: (state) => {
            state.loading = true;
        },
        [postAddEditOption.fulfilled.type]: (state, action) => {
            state.postAddCart = action.payload;
            state.loading = false;
            state.error = null;
        },
        [postAddEditOption.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        
        //Delete Add Cart Excercise Option View
        [postExercisedOptionForCancel.pending.type]: (state) => {
            state.loading = true;
        },
        [postExercisedOptionForCancel.fulfilled.type]: (state, action) => {
            state.postAddCart = action.payload;
            state.loading = false;
            state.error = null;
        },
        [postExercisedOptionForCancel.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Excercise Option View
        [getExerciseCart.pending.type]: (state) => {
            state.loading = true;
        },
        [getExerciseCart.fulfilled.type]: (state, action) => {
            state.postAddCart = action.payload;
            state.loading = false;
        },
        [getExerciseCart.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Payment Mode View
        [getPaymentType.pending.type]: (state) => {
            state.loading = true;
        },
        [getPaymentType.fulfilled.type]: (state, action) => {
            state.paymentmodeDetail = action.payload;
            state.loading = false;
        },
        [getPaymentType.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        
        //post Confirm Excercise Option View
        [postConfirmExercise.pending.type]: (state) => {
            state.loading = true;
        },
        [postConfirmExercise.fulfilled.type]: (state, action) => {
            state.NewUserResponseMessage = action.payload
            state.loading = false;
            state.error = null;
        },
        [postConfirmExercise.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
    }
})
export default ExcerciseoptionSlice